
export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-[#A8D5E2]/5 to-[#F4C2C2]/5 py-16">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/7eba06d2-2703-459d-ada7-85a913ba6307.png" 
              alt="Simone Santos Psicóloga" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-sm text-gray-600 leading-relaxed">
              Atendimento psicológico com ética, empatia e responsabilidade. Cuidando da sua saúde mental com abordagem em Terapia Cognitivo-Comportamental.
            </p>
          </div>

          <div>
            <h3 className="text-base font-medium text-gray-800 mb-4">Contato</h3>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-[#A8D5E2]/20 rounded-full flex-shrink-0">
                  <i className="ri-phone-line text-sm text-[#A8D5E2]"></i>
                </div>
                <a 
                  href="https://wa.me/5511959099459" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-[#A8D5E2] transition-colors cursor-pointer"
                >
                  (11) 95909-9459
                </a>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-[#F4C2C2]/20 rounded-full flex-shrink-0">
                  <i className="ri-instagram-line text-sm text-[#F4C2C2]"></i>
                </div>
                <a 
                  href="https://instagram.com/simonesantospsi" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-[#F4C2C2] transition-colors cursor-pointer"
                >
                  @simonesantospsi
                </a>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-[#B8E6D5]/20 rounded-full flex-shrink-0">
                  <i className="ri-map-pin-line text-sm text-[#B8E6D5]"></i>
                </div>
                <span className="text-sm text-gray-600">
                  Várzea Paulista - SP
                </span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-base font-medium text-gray-800 mb-4">Horário de Atendimento</h3>
            <p className="text-sm text-gray-600 leading-relaxed mb-4">
              Atendimento mediante agendamento prévio. Entre em contato para verificar disponibilidade.
            </p>
            <a
              href="https://wa.me/5511959099459"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm text-[#A8D5E2] hover:text-[#8FC5D4] transition-colors font-medium cursor-pointer"
            >
              Agendar consulta
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-600 text-center md:text-left">
              © 2025 Simone Santos - Psicóloga. Todos os direitos reservados.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-gray-500 hover:text-[#A8D5E2] transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
